export default "__VITE_ASSET__DIuRz0II__"